export const schainStatusItems = [
  { id: 'origin', name: 'Original' },
  { id: 'complete', name: '1' },
  { id: 'nocomplete', name: '0' },
];